<template>
  <section>
    <ChooseTmpl
      ref="chooseTmpl"
      title="选择车辆"
      :resultVal="resultVal"
      :isRadio="isRadio"
      :otherSearchData="otherSearchData"
      :searchBoxDataTmpl="searchBoxDataTmpl"
      :getListApi="getListApi"
      :tableTitle="tableTitle"
      :tableSelectTar="tableSelectTar"
      :showTableTitle="showTableTitle"
      @change="handleResultChange"
      :handleSearchData="handleSearchData"
      :handleResParams="handleResParams"
      :customShow="customShow"
      :showName="showName"
      :clearable="clearable"
      :disabled="disabled"
      :isInput="isInput"
      :placeholder="placeholder"
    >
      <section slot="tableSlot" slot-scope="scope">
        <section v-if="scope.column.property === 'remark'" style="white-space: nowrap;text-overflow: ellipsis;overflow: hidden;">
          <el-popover placement="top-start" width="120" trigger="hover">
            <div >
              <p>{{ scope.row[scope.column.property]}}</p>
            </div>
            <span class="cur" slot="reference">{{scope.row[scope.column.property]}}</span>
          </el-popover>
        </section>
        <section v-else>{{scope.row[scope.column.property]}}</section>
      </section>
    </ChooseTmpl>
  </section>
</template>

<script>
import {
  doQueryVehicleAll,
} from 'api/car';
import {
  getEnumList,
} from 'api';
import ChooseTmpl from 'components/choose/tmpl/tmpl.vue';
export default {
  components: {
    ChooseTmpl,
  },
  model: {
    prop: 'resultVal', // 父级传进来的值
    event: 'change',
  },
  props: {
    clearable: { // 清除按钮
      type: Boolean,
      default: false,
    },
    resultVal: {
      default: '',
    },
    isRadio: {
      type: Boolean,
      default: false,
    },
    otherSearchData: {
      type: Object,
      default: () => ({}),
    },
    customShow: { // 是否自定义展示结果
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    isInput: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: '请选择',
    },
  },
  data () {
    return {
      showName: 'plateNumber',
      tableSelectTar: 'vehicleCode',
      searchBoxDataTmpl: {
        vehicleClassOptions: [],
        authStateInOptions: [],
        form: [
          { // 车牌号码
            label: '车牌号码',
            value: 'plateNumber',
            type: 'input',
            placeholder: '请输入车牌号码',
          },
          {
            label: '司机姓名',
            value: 'linkman',
            type: 'input',
            placeholder: '请输入司机姓名',
          },
          {
            label: '司机手机',
            value: 'mobilePhone',
            type: 'input',
            placeholder: '请输入司机手机',
          },
          {
            label: '车辆种类',
            value: 'vehicleClass',
            type: 'select',
            placeholder: '请输入车辆种类',
            default: '-1',
          },
          {
            label: '认证状态',
            value: 'authStateIn',
            type: 'select',
            placeholder: '请输入认证状态',
            default: '-1',
          },
        ],
      },
      showTableTitle: [
        {
          prop: 'plateNumber',
          label: '车牌号码',
        },
      ],
      tableTitle: [
        {
          prop: 'plateNumber',
          label: '车牌号码',
        },
        {
          prop: 'customDriverInfo',
          label: '司机信息',
        },
        {
          prop: 'vehicleClassName',
          label: '车辆种类',
        },
        {
          prop: 'remark',
          label: '备注',
          w: 150,
        },
        {
          prop: 'vehicleInfo',
          label: '车型',
        },
        {
          prop: 'tenantName',
          label: '归属车队',
        },
        {
          prop: 'authStateName',
          label: '认证状态',
        },
      ],
    };
  },
  methods: {
    getListApi: doQueryVehicleAll,
    handleResParams (res) {
      if (!res.failed && res.items && res.items.length) {
        for (let item of res.items) {
          // 展示成 司机姓名/司机手机号
          item.customDriverInfo = (item.linkman ? item.linkman + '/' : '') + (item.mobilePhone || '');
        }
      }
    },
    handleResultChange (val) {
      this.$emit('change', val);
    },
    handleSearchData (searchBoxData) {
      searchBoxData.isAuth = '-1';
      searchBoxData.isAll = true;
      return searchBoxData;
    },
    show () {
      this.$refs.chooseTmpl.show();
    },
  },
  async created () {
    const enumsList = await getEnumList({
      codeType: 'VEHICLE_CLASS,CUSTOMER_AUTH_STATE',
    });
    const safeEnum = (index) => (Array.isArray(enumsList) && Array.isArray(enumsList[index])) ? enumsList[index] : [];
    this.searchBoxDataTmpl.vehicleClassOptions = [
      { label: '全部', value: '-1' },
      ...safeEnum(0),
    ];
    this.searchBoxDataTmpl.authStateInOptions = [
      { label: '全部', value: '-1' },
      ...safeEnum(1),
    ];
  },
};
</script>

<style>
</style>
